import UserAltIcon from '@material-ui/icons/PeopleAlt';
import UserList from './UserList';

export const Users: object = {
  list: UserList,
  icon: UserAltIcon,
};

export default Users;
